export default __webpack_public_path__ + "static/media/NewManagement(1).17e20b96.png";